import React, { useEffect } from 'react'
import { useContext, useState } from 'react'
import cross from '../../../../assets/orders/cross.svg'
import ModalContext from '../../../../contexts/ModalContext'
import SectionContext from '../../../../contexts/SectionContext'
import plus from '../../../../assets/headers/plus.svg'
import save from '../../../../assets/router/save.svg'
import axios from 'axios'
import { mock } from './utils'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  InputDiv,
  InputLabel,
  StyledSelect,
  StyledOption,
  LineDiv,
  StyledDate,
  Input,
  GridContainer,
  ButtonOfSection,
  ButtonOfSectionText,
  PlusImg,
  OptionsDiv,
  SelectContainer,
  SelectData,
  ConformityStatus,
  CenterItensContainer,
} from './style'
import { FreightContext } from '../../../../contexts/FreightContext'
import { ButtonImage } from '../../../Orders/DetailsModal/style'
import { set } from 'date-fns'
import { de } from 'date-fns/locale'
import { read } from 'xlsx'
import { ButtonCreate } from '../../style'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import { useNavigate } from 'react-router-dom'
import ModalTest from '../../../BaseModal'
import { Check, Info } from 'lucide-react'
import SelectCustomerInFreight from './searchClient'

const FreightForm = () => {
  // Funções auxiliares para conversão de formatos de data
  const formatToDateInput = (dateString: string): string => {
    if (!dateString || dateString.length < 10) return ''
    const [day, month, year] = dateString.split('/')
    return `${year}-${month}-${day}`
  }

  const formatFromDateInput = (dateString: string): string => {
    if (!dateString || dateString.length < 10) return ''

    // Verifica se a data está no formato YYYY-MM-DD
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/
    if (!dateRegex.test(dateString)) return ''

    const [year, month, day] = dateString.split('-')

    // Verifica se o ano tem 4 dígitos
    if (year.length !== 4) return ''

    return `${day}/${month}/${year}`
  }

  const handleDateChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: 'deadLine' | 'readyToShip',
  ) => {
    const value = e.target.value

    // Verifica se o valor tem mais de 10 caracteres (YYYY-MM-DD)
    if (value.length > 10) {
      e.target.value = value.slice(0, 10)
      return
    }

    // Verifica se o ano tem mais de 4 dígitos
    if (value.length === 10) {
      const year = value.split('-')[0]
      if (year.length > 4) {
        e.target.value = value.slice(0, 6) + value.slice(7) // Remove o dígito extra
        return
      }
    }

    if (type === 'deadLine') {
      handleDeadlineChange(value)
    } else {
      handleReadyToShipChange(value)
    }
  }

  const dataFormatter = (isoDateString: string): string => {
    if (!isoDateString) {
      return '' // Retorna vazio se a string for nula ou vazia
    }

    const dateUtc = new Date(isoDateString)

    // Verifica se a data é válida antes de tentar formatar
    if (isNaN(dateUtc.getTime())) {
      console.error('Data ISO inválida recebida:', isoDateString)
      return '' // Trata o caso de uma string de data inválida
    }

    // Extrai as partes da data diretamente do UTC
    const year = dateUtc.getUTCFullYear()
    const month = dateUtc.getUTCMonth() + 1 // getUTCMonth é 0-indexado, então adiciona 1
    const day = dateUtc.getUTCDate()

    // Garante que mês e dia tenham dois dígitos (ex: 01 em vez de 1)
    const formattedMonth = month < 10 ? `0${month}` : month
    const formattedDay = day < 10 ? `0${day}` : day

    return `${formattedDay}/${formattedMonth}/${year}`
  }

  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { routerSection, setRouterSection } = useContext(SectionContext)
  const [value, setValue] = useState('Selecione')
  const [selectedClient, setSelectedClient] = useState<string | null>(null)
  const [selectedType, setSelectedType] = useState<string | null>(null)
  const [street, setStreet] = useState<string | null>(null)
  const [neighborhood, setNeighborhood] = useState<string | null>(null)
  const [city, setCity] = useState<string | null>(null)
  const [uf, setUf] = useState<string | null>(null)
  const [number, setNumber] = useState<number | null>(null)
  const clients: string[] = ['Luis', 'João', 'Richard']
  const types: string[] = ['Entrega', 'Retirada', 'Sem endereço']
  const { freight, setFreight } = useContext(FreightContext)
  const [cep, setCep] = useState(freight?.address?.cep || '')
  const { setFeedback } = useContext(FeedbackContext)
  const [companies, setCompanies] = useState<any[]>([])
  const [observation, setObservation] = useState<string>(
    freight?.observation || '',
  )
  const [orderNumber, setOrderNumber] = useState<string>(
    freight?.orderNumber || '',
  )
  const [duplicateBlocker, setDuplicateBlocker] = useState<boolean>(false)
  const [company, setCompany] = useState<{ id: number; companyName: string }>({
    id: freight?.company?.id || 0,
    companyName: freight?.company?.companyName || '',
  })
  const navigate = useNavigate()
  const [addressPostBody, setAddressPostBody] = useState({
    cep: freight?.address?.cep || '',
    street: freight?.address?.street || '',
    number: freight?.address?.number || '',
    complement: freight?.address?.complement || '',
    neighborhood: {
      name: freight?.address?.neighborhood?.name || '',
      id: freight?.address?.neighborhood?.id || 0,
    },
    city: {
      name: freight?.address?.neighborhood?.city?.name || '',
      id: freight?.address?.neighborhood?.city?.id || 0,
    },
    state: {
      name: freight?.address?.neighborhood?.city?.state?.name || '',
      id: freight?.address?.neighborhood?.city?.state?.id || 0,
    },
  })
  const [addressPutBody, setAddressPutBody] = useState({
    id: freight?.address?.id,
    cep: freight?.address?.cep || '',
    street: freight?.address?.street || '',
    number: freight?.address?.number || '',
    complement: freight?.address?.complement || '',
    neighborhood: {
      name: freight?.address?.neighborhood?.name || '',
      id: freight?.address?.neighborhood?.id || 0,
    },
    city: {
      name: freight?.address?.neighborhood?.city?.name || '',
      id: freight?.address?.neighborhood?.city?.id || 0,
    },
    state: {
      name: freight?.address?.neighborhood?.city?.state?.name || '',
      id: freight?.address?.neighborhood?.city?.state?.id || 0,
    },
  })
  const [formData, setFormData] = useState({
    type: freight?.type || 'Entrega',
    detail: freight?.detail || '',
    observastion: freight?.observation || '',
    deadLine: freight?.deadLine ? dataFormatter(freight.deadLine) : '',
    readyToShip: freight?.readyToShip ? dataFormatter(freight.readyToShip) : '',
    address: {
      street: freight?.address?.street || '',
      number: freight?.address?.number || '',
      complement: freight?.address?.complement || '',
      cep: freight?.address?.cep || '',
      neighborhood: {
        name: freight?.address?.neighborhood?.name || '',
        city: {
          name: freight?.address?.neighborhood?.city?.name || '',
          state: {
            name: freight?.address?.neighborhood?.city?.state?.name || '',
          },
        },
      },
    },
    load: {
      height: freight?.load.height || 0,
      width: freight?.load.width || 0,
      length: freight?.load.length || 0,
      cubage: freight?.load.cubage || 0,
      weight: freight?.load.weight || 0,
      detail: freight?.load.detail || '',
    },
  })

  const getCompanies = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies`,
      { params: { filters: ['1', '2'] } },
    )
    setCompanies(response.data)
  }

  const handleDeadlineChange = (date: string) => {
    const formatted = formatFromDateInput(date)
    setFormData((prev) => ({
      ...prev,
      deadLine: formatted,
    }))
  }

  const handleReadyToShipChange = (date: string) => {
    const formatted = formatFromDateInput(date)
    setFormData((prev) => ({
      ...prev,
      readyToShip: formatted,
    }))
  }

  const handleDataChange = (path: string, value: any) => {
    setFormData((prev) => {
      const keys = path.split('.')
      const updated = { ...prev }
      let current: any = updated

      keys.slice(0, -1).forEach((key) => {
        if (!current[key]) current[key] = {}
        current = current[key] as Record<string, any>
      })

      current[keys[keys.length - 1]] = value
      return updated
    })

    if (path.includes('address')) {
      if (freight) {
        setAddressPutBody((prev) => ({
          ...prev,
          [path.split('.').pop()!]: value,
        }))
      } else {
        setAddressPostBody((prev) => ({
          ...prev,
          [path.split('.').pop()!]: value,
        }))
      }
    }
  }

  useEffect(() => {
    if (freight?.address?.cep) {
      setNumber(Number(freight.address.number))
      setSelectedClient(freight.company?.companyName || '')
      setFormData((prevData) => ({
        ...prevData,
        deadLine: freight?.deadLine ? dataFormatter(freight.deadLine) : '',
        readyToShip: freight?.readyToShip
          ? dataFormatter(freight.deadLine)
          : '',
        address: {
          ...prevData.address,
          cep:
            String(freight.address.cep).slice(0, 5) +
            '-' +
            String(freight.address.cep).slice(5),
          street: freight.address.street,
          neighborhood: {
            name: freight.address.neighborhood.name,
            city: {
              name: freight.address.neighborhood.city.name,
              state: {
                name: freight.address.neighborhood.city.state.name,
                uf: freight.address.neighborhood.city.state.uf,
              },
            },
          },
          number: freight.address.number,
          complement: freight.address.complement,
        },
        load: {
          ...prevData.load,
          height: freight.load.height,
          width: freight.load.width,
          weight: freight.load.weight,
          length: freight.load.length,
          cubage: freight.load.cubage,
          detail: freight.load.detail,
        },
      }))
    }
  }, [freight])

  const handleClick = () => {
    setModalSection('router')
    setModalActive(true)
  }

  const dataFormatterISO = (dateString: string): string => {
    // Verifica se a string de data está no formato esperado (dd/mm/yyyy)
    const parts = dateString.split('/')
    if (parts.length !== 3) {
      console.error(
        "Formato de data inválido. Esperado 'dd/mm/yyyy'. Recebido:",
        dateString,
      )
      // Ou você pode lançar um erro: throw new Error("Formato de data inválido.");
      return '' // Retorna uma string vazia ou trata o erro como preferir
    }

    const [day, month, year] = parts

    // Constrói um objeto Date em UTC para evitar problemas de fuso horário local
    // Lembre-se que o mês no construtor de Date é 0-indexado (Janeiro = 0, Fevereiro = 1, etc.)
    const dateObject = new Date(
      Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)),
    )

    // Opcional: Validação para datas inválidas (ex: "30/02/2025")
    // Se a data fornecida for inválida, Date.UTC() ainda pode criar um objeto Date,
    // mas com o dia "corrigido" (ex: 30/02 vira 02/03).
    // Esta verificação garante que a data original era logicamente válida.
    if (
      dateObject.getUTCFullYear() !== parseInt(year) ||
      dateObject.getUTCMonth() !== parseInt(month) - 1 ||
      dateObject.getUTCDate() !== parseInt(day)
    ) {
      console.error("A data original ('" + dateString + "') é inválida.")
      return '' // Retorna string vazia ou trata o erro
    }

    // Converte o objeto Date para a string ISO 8601 (ex: "2025-02-28T00:00:00.000Z")
    return dateObject.toISOString()
  }

  const close = () => {
    // setModalActive(false);
    // setFreight(null)
    navigate('..')
  }

  const postFreight = async () => {
    setDuplicateBlocker(true)
    try {
      const token = localStorage.getItem('token')
      
      let address = null
      if (selectedType !== 'Sem endereço') {
        setAddressPostBody((prev) => ({
          ...prev,
          street: formData.address.street,
          number: formData.address.number,
          complement: formData.address.complement,
        }))
        address = addressPostBody
      }
      
      console.log(addressPostBody.street)
      const body = {
        address: address,
        type: selectedType,
        detail: formData.detail,
        observation: observation,
        orderNumber: orderNumber,
        deadLine: dataFormatterISO(formData.deadLine),
        readyToShip: dataFormatterISO(formData.readyToShip),
        companyId: company.id,
        routeId: null,
        load: {
          height: Number(formData.load.height),
          width: Number(formData.load.width),
          length: Number(formData.load.length),
          cubage: Number(formData.load.cubage),
          weight: Number(formData.load.weight),
          detail: formData.load.detail,
        },
      }
      console.log(body)
      if (!freight) {
        const response = await axios.post(
          `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight`,
          body,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          }
        )
        if (response.data) { 
          setFeedback({
            isOpen: true,
            message: 'Frete cadastrado com sucesso!',
            statusOk: true,
          })
          setDuplicateBlocker(false)
          close()
        }
      }
    } catch {
      setFeedback({
        isOpen: true,
        message: 'Erro ao criar frete',
        statusOk: false,
      })
      setDuplicateBlocker(false)
    }
  }

  const putFreight = async () => {
    setDuplicateBlocker(true)
    try {
      let address = null
      if (selectedType !== 'Sem endereço') {
        setAddressPostBody((prev) => ({
          ...prev,
          street: formData.address.street,
          number: formData.address.number,
          complement: formData.address.complement,
        }))
        address = addressPostBody
      }
      const body = {
        address: addressPutBody,
        type: selectedType,
        detail: formData.detail,
        observation: observation,
        orderNumber: orderNumber,
        deadLine: dataFormatterISO(formData.deadLine),
        companyId: company.id,
        routeId: freight?.routeId,
        readyToShip: dataFormatterISO(formData.readyToShip),
        load: {
          height: Number(formData.load.height),
          width: Number(formData.load.width),
          length: Number(formData.load.length),
          cubage: Number(formData.load.cubage),
          weight: Number(formData.load.weight),
          detail: formData.load.detail,
        },
      }

      const response = await axios.put(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight/${freight?.id}`,
        body,
      )
      if (response.data) {
        setFeedback({
          isOpen: true,
          message: 'Frete atualizado!',
          statusOk: true,
        })
        setDuplicateBlocker(false)
        close()
      }
    } catch {
      setFeedback({
        isOpen: true,
        message: 'Erro ao criar frete',
        statusOk: false,
      })
      setDuplicateBlocker(false)
    }
  }

  const getCep = async (cep: string) => {
    const digits = cep.replace(/\D/g, '')

    let formatted = ''

    if (digits.length > 0) {
      formatted += digits.substring(0, Math.min(5, digits.length))

      if (digits.length > 5) {
        formatted += '-' + digits.substring(5, Math.min(8, digits.length))
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      address: {
        ...prevData.address,
        cep: formatted,
      },
    }))

    if (formatted.length === 9) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/address/cep`,
          { cep },
        )
        const data = response.data
        if (freight) {
          setAddressPutBody((prevData) => ({
            ...prevData,
            cep: cep.replace(/\D/g, ''),
            street: data.street,
            city: {
              name: data.city.name,
              id: data.city.id,
            },
            neighborhood: {
              name: data.neighborhood.name,
              id: data.neighborhood.id,
            },
            state: {
              name: data.state.name,
              id: data.state.id,
            },
          }))
        } else {
          setAddressPostBody((prevData) => ({
            ...prevData,
            cep: cep.replace(/\D/g, ''),
            street: data.street,
            city: {
              name: data.city.name,
              id: data.city.id,
            },
            neighborhood: {
              name: data.neighborhood.name,
              id: data.neighborhood.id,
            },
            state: {
              name: data.state.name,
              id: data.state.id,
            },
          }))
        }

        setFormData((prevData) => ({
          ...prevData,
          address: {
            ...prevData.address,
            cep: cep,
            street: data.street,
            neighborhood: {
              name: data.neighborhood.name,
              city: {
                name: data.city.name,
                state: {
                  name: data.state.name,
                },
              },
            },
          },
        }))
      } catch (error) {
        console.error('Erro ao buscar o CEP:', error)
        setFeedback({
          isOpen: true,
          message: 'CEP inexistente',
          statusOk: false,
        })
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        cep: cep.replace('-', ''),
        street: '',
        neighborhood: '',
        city: '',
        state: '',
      }))
    }
  }

  useEffect(() => {
    setAddressPutBody({
      id: freight?.address?.id,
      cep: freight?.address?.cep || '',
      street: freight?.address?.street || '',
      number: freight?.address?.number || '',
      complement: freight?.address?.complement || '',
      neighborhood: {
        name: freight?.address?.neighborhood?.name || '',
        id: freight?.address?.neighborhood?.id || 0,
      },
      city: {
        name: freight?.address?.neighborhood?.city?.name || '',
        id: freight?.address?.neighborhood?.city?.id || 0,
      },
      state: {
        name: freight?.address?.neighborhood?.city?.state?.name || '',
        id: freight?.address?.neighborhood?.city?.state?.id || 0,
      },
    })
  }, [freight])

  const handleClient = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newClient = e.target.value
    if (newClient === selectedClient) {
      setSelectedClient(null)
    } else {
      setSelectedClient(newClient)
    }
  }

  const handleType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newType = e.target.value
    setSelectedType(newType)
    setFormData((prevData) => ({
      ...prevData,
      type: newType,
    }))
  }

  useEffect(() => {
    getCompanies()
  }, [])

  useEffect(() => {
    setSelectedType(freight?.type || 'Entrega')
  }, [freight])

  return (
    <ModalTest>
      <Container>
        <GridContainer>
          <HeaderDiv style={{ gridArea: `titleNew` }}>
            <HeaderText>{!freight ? 'Novo frete' : 'Editar frete'}</HeaderText>
            <CloseDiv onClick={() => close()}>
              <CloseImg src={cross} alt='Close tab' />
            </CloseDiv>
          </HeaderDiv>

          <InputDiv className='client' style={{ gridArea: `client` }}>
            <SelectContainer>
              <CenterItensContainer>
                <InputLabel>Empresa demandante</InputLabel>
                <ConformityStatus isvalue={!company.id}>
                  {company.id ? (
                    <>
                      <Check size={20} />{' '}
                    </>
                  ) : (
                    <>
                      <Info size={18} />{' '}
                    </>
                  )}
                </ConformityStatus>
              </CenterItensContainer>

              {/* <SelectData 
            value={selectedClient || (freight?.company?.companyName)} 
            onChange={handleClient}
            className="client"
        >
            <StyledOption value={freight?.company?.id || ''} >
                { freight?.company?.companyName || 'Selecione...'}
            </StyledOption>
            {companies.map((client)=>(
                <StyledOption value={client.id} key={client.id}>
                    {client.companyName}
                </StyledOption>
            ))}
        </SelectData> */}

              <SelectCustomerInFreight
                client={company}
                setClient={setCompany}
              />
            </SelectContainer>
            {/* <ButtonOfSection style={{width: `3rem`}}>
        <PlusImg src={plus} />
    </ButtonOfSection> */}
          </InputDiv>

          <InputDiv style={{ gridArea: `type` }}>
            <SelectContainer>
              <CenterItensContainer>
                {' '}
                <InputLabel>Tipo</InputLabel>
              </CenterItensContainer>
              <SelectData
                value={selectedType || freight?.type || ''}
                onChange={handleType}
              >
                <StyledOption value={freight?.type || ''} disabled>
                  {freight?.type || 'Selecione...'}
                </StyledOption>
                {types.map((type) => (
                  <StyledOption value={type} key={type}>
                    {type}
                  </StyledOption>
                ))}
              </SelectData>
            </SelectContainer>
          </InputDiv>

          <InputDiv style={{ gridArea: `orderNumber` }}>
            <CenterItensContainer>
              <InputLabel>Numero de venda</InputLabel>
            </CenterItensContainer>
            <Input
              onChange={(e) => setOrderNumber(e.target.value)}
              value={orderNumber || ''}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `date` }}>
            <CenterItensContainer>
              <InputLabel>Data limite</InputLabel>
              <ConformityStatus isvalue={formData.deadLine.length < 10}>
                {!(formData.deadLine.length < 10) ? (
                  <>
                    <Check size={20} />{' '}
                  </>
                ) : (
                  <>
                    <Info size={18} />{' '}
                  </>
                )}
              </ConformityStatus>
            </CenterItensContainer>
            <StyledDate
              type='date'
              // onFocus={(e) => {
              //     (e.target.type = "date")
              //     e.target.style.setProperty('background-image', 'none');
              // }}
              onChange={(e) => handleDateChange(e, 'deadLine')}
              value={formatToDateInput(formData.deadLine)}
              max='9999-12-31'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `readyToShip` }}>
            <CenterItensContainer>
              <InputLabel>Liberado pra expedir</InputLabel>
              <ConformityStatus isvalue={formData.readyToShip.length < 10}>
                {!(formData.readyToShip.length < 10) ? (
                  <>
                    <Check size={20} />{' '}
                  </>
                ) : (
                  <>
                    <Info size={18} />{' '}
                  </>
                )}
              </ConformityStatus>
            </CenterItensContainer>
            <StyledDate
              type='date'
              // onFocus={(e) => {
              //     (e.target.type = "date")
              //     e.target.style.setProperty('background-image', 'none');
              // }}
              onChange={(e) => handleDateChange(e, 'readyToShip')}
              value={formatToDateInput(formData.readyToShip)}
              max='9999-12-31'
            />
          </InputDiv>

          {selectedType !== 'Sem endereço' && (
            <>
              <LineDiv></LineDiv>
              <HeaderDiv style={{ gridArea: `titleAdd` }}>
                <HeaderText>
                  Endereço{' '}
                  {(selectedType?.includes('Entrega') && 'de entrega') ||
                    'de coleta'}
                </HeaderText>
              </HeaderDiv>

              <InputDiv style={{ gridArea: `cep` }}>
                <InputLabel>CEP</InputLabel>
                <Input
                  onChange={(e) => {
                    handleDataChange('address.cep', e.target.value)
                    getCep(e.target.value)
                  }}
                  maxLength={9}
                  value={formData.address.cep || ''}
                  placeholder='Digite aqui'
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `street` }}>
                <InputLabel>Logradouro</InputLabel>
                <Input
                  placeholder='Digite aqui'
                  value={formData.address.street ?? ''}
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `neighborhood` }}>
                <InputLabel>Bairro</InputLabel>
                <Input
                  placeholder='Digite aqui'
                  value={formData.address.neighborhood.name ?? ''}
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `number` }}>
                <InputLabel>Número</InputLabel>
                <Input
                  onChange={(e) =>
                    handleDataChange('address.number', e.target.value)
                  }
                  value={formData.address.number || ''}
                  placeholder='Digite aqui'
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `state` }}>
                <InputLabel>Estado</InputLabel>
                <Input
                  placeholder='Digite aqui'
                  value={formData.address.neighborhood.city.state.name ?? ''}
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `city` }}>
                <InputLabel>Cidade</InputLabel>
                <Input
                  placeholder='Digite aqui'
                  value={formData.address.neighborhood.city.name ?? ''}
                />
              </InputDiv>

              <InputDiv style={{ gridArea: `complement` }}>
                <InputLabel>Complemento</InputLabel>
                <Input
                  onChange={(e) =>
                    handleDataChange('address.complement', e.target.value)
                  }
                  value={formData.address.complement || ''}
                  placeholder='Digite aqui'
                />
              </InputDiv>
            </>
          )}

          <LineDiv style={{ gridArea: `line2` }}></LineDiv>
          <HeaderDiv style={{ gridArea: `titleLoad` }}>
            <HeaderText>Carga</HeaderText>
          </HeaderDiv>

          <InputDiv style={{ gridArea: `height` }}>
            <InputLabel>Altura</InputLabel>
            <Input
              onChange={(e) =>
                handleDataChange(
                  'load.height',
                  e.target.value.replace(',', '.'),
                )
              }
              value={formData.load.height}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `width` }}>
            <InputLabel>Largura</InputLabel>
            <Input
              onChange={(e) =>
                handleDataChange('load.width', e.target.value.replace(',', '.'))
              }
              value={formData.load.width}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `length` }}>
            <InputLabel>Comprimento</InputLabel>
            <Input
              onChange={(e) =>
                handleDataChange(
                  'load.length',
                  e.target.value.replace(',', '.'),
                )
              }
              value={formData.load.length}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `cubage` }}>
            <InputLabel>Cubagem</InputLabel>
            <Input
              onChange={(e) =>
                handleDataChange(
                  'load.cubage',
                  e.target.value.replace(',', '.'),
                )
              }
              value={formData.load.cubage}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `weight` }}>
            <InputLabel>{'Peso (Kg)'}</InputLabel>
            <Input
              onChange={(e) =>
                handleDataChange(
                  'load.weight',
                  e.target.value.replace(',', '.'),
                )
              }
              value={formData.load.weight}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <InputDiv style={{ gridArea: `detail` }}>
            <InputLabel>Detalhe</InputLabel>
            <Input
              onChange={(e) => handleDataChange('load.detail', e.target.value)}
              value={formData.load.detail || ''}
              placeholder='Digite aqui'
            />
          </InputDiv>

          <LineDiv style={{ gridArea: `line3` }}></LineDiv>
          <InputDiv style={{ gridArea: `observation` }}>
            <InputLabel>Observação</InputLabel>
            <Input
              onChange={(e) => setObservation(e.target.value)}
              value={observation || ''}
              placeholder='Digite aqui'
            />
          </InputDiv>
        </GridContainer>

        <OptionsDiv>
          <ButtonCreate className='reverse' onClick={() => close()}>
            Cancelar
          </ButtonCreate>

          {duplicateBlocker ? (
            <ButtonCreate className='disable'>Aguarde..</ButtonCreate>
          ) : (
            <ButtonCreate
              onClick={async () => {
                if (!freight) {
                  await postFreight()
                } else {
                  await putFreight()
                }
              }}
            >
              <img src={!freight ? plus : save}></img>
              {!freight ? 'Salvar frete' : 'Salvar alterações'}
            </ButtonCreate>
          )}
        </OptionsDiv>
      </Container>
    </ModalTest>
  )
}

export default FreightForm
